import PropTypes from 'prop-types';
import React from 'react';
import { Field, FormSection } from 'redux-form';
import { SelectField } from 'redux-form-material-ui';
import { MenuItem } from 'material-ui';
import _ from 'lodash';
import { CAMPAIGN_FORM_KEYS as FORM_KEYS } from '../../../constants';
import { presence } from 'dash-front/helpers/validation';

const WidgetForm = ({ widgets = [], templates = [], onChange }) => {
    const socialWidgets = Array.isArray(widgets) ? widgets.filter(w => _.get(w, 'spec.social')) : [];

    const handleChange = (event, value) => {
        if (onChange) {
            onChange({ widget: socialWidgets.find(w => w.id === value), value });
        }
    };
    return (
        <div>
            <div>
                <Field
                    name={FORM_KEYS.WIDGET.NAME}
                    floatingLabelText={'Widget'}
                    component={SelectField}
                    onChange={handleChange}
                    validate={presence}
                >
                    {socialWidgets.map(widget => (
                        <MenuItem key={widget.id} value={widget.id} primaryText={widget.name} />
                    ))}
                </Field>
            </div>
            <FormSection name={FORM_KEYS.WIDGET.PARAMS.SECTION}>
                <div>
                    <Field
                        name={FORM_KEYS.WIDGET.PARAMS.TEMPLATE}
                        floatingLabelText={'Template'}
                        component={SelectField}
                        validate={presence}
                    >
                        {templates
                            .filter(el => !el.isHidden)
                            .map(template => (
                                <MenuItem key={template._id} value={template.id} primaryText={template.name} />
                            ))}
                    </Field>
                </div>
            </FormSection>
        </div>
    );
};

WidgetForm.propTypes = {
    widgets: PropTypes.array,
    templates: PropTypes.array,
    onChange: PropTypes.func
};

export default WidgetForm;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/WidgetForm.js
 **/